import { inject, Injectable, Signal, signal } from '@angular/core';
import { IUserOrganization } from '@interfaces/user-organization.interface';
import { StorageService } from 'ngx-lib';

@Injectable({
    providedIn: 'root'
})
export class UserOrganizationStorageService {
    selectedOrganization: Signal<IUserOrganization | undefined>;

    private readonly storageService: StorageService = inject(StorageService);

    private readonly STORAGE_KEY = 'organization';
    private readonly _selectedOrganization = signal<IUserOrganization | undefined>(
        this.storageService.getItem<IUserOrganization>(this.STORAGE_KEY)
    );

    constructor() {
        this.selectedOrganization = this._selectedOrganization.asReadonly();
    }

    getUserOrganization(): IUserOrganization | undefined {
        return this._selectedOrganization();
    }

    setUserOrganization(organization: IUserOrganization): void {
        const currentOrg = this._selectedOrganization();
        const nextOrganization: IUserOrganization = {
            ...organization,
            code: organization.code ?? (currentOrg?.id === organization.id ? currentOrg.code : undefined)
        };

        this.storageService.setItem(this.STORAGE_KEY, nextOrganization);
        this._selectedOrganization.set(nextOrganization);
    }

    removeUserOrganization(): void {
        this.storageService.removeItem(this.STORAGE_KEY);
        this._selectedOrganization.set(undefined);
    }

    updateUserOrganization(newOrg: IUserOrganization): void {
        const currentOrg = this._selectedOrganization();
        if (!currentOrg) {
            return;
        }

        const idChanged = JSON.stringify(currentOrg.id) !== JSON.stringify(newOrg.id);
        const shouldBackfillCode = !currentOrg.code && !!newOrg.code;

        if (idChanged || shouldBackfillCode) {
            this.setUserOrganization(newOrg);
        }
    }
}
